import React, { useEffect, useState } from "react";
import "./App.css";
import "./app/assets/css/style.css";
import RouteController from "./app/routes/RouteController";
import { useDispatch } from "react-redux";
import { getFingerprint } from "./app/redux/slices/fingerprintSlice";
import { getAuth } from "./app/redux/slices/authSlice";
import { getUser, getUserEmail } from "./app/libs/user";
import {
  setAFCustomerUserId,
  setClevertapProfile,
  setUtmData,
} from "./app/libs/events";
import { fetchRemoteConfig } from "./app/services/remoteConfig";
import { getParameterFromURL, isMobileDevice } from "./app/libs/utils";
import { appConfig } from "./app/redux/slices/appSlice";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFingerprint());
    dispatch(getAuth());
  }, [dispatch]);

  useEffect(() => {
    // Initialize once on app start
    if (process.env.REACT_APP_ENV === "production") {
      window.console.log = function () {};
    }

    setUtmData();
    getUser()
      .then((response) => {
        setAFCustomerUserId(response.user.id);
      })
      .catch(() => {});

    setClevertapProfile({ email: getUserEmail() });
  }, []);

  useEffect(() => {
    dispatch(appConfig({ isMobileDevice: isMobileDevice() }));
    const banktype = getParameterFromURL("banktype");
    if (banktype) {
      try {
        sessionStorage.setItem("banktype", banktype);
      } catch (e) {
        // ignore
      }
    }

    fetchRemoteConfig()
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch]);

  return <RouteController />;
}

export default App;
